import { Button, Form, Input, Modal, Radio, Select, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
// import { useAppDispatch } from "../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { getTemplateOptions, exportTemplate } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { RootState } from "../../../../redux/store";
import "./exportModal.css";
import { useNavigate } from "react-router";
import { useWatch } from "antd/es/form/Form";

type ExportModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
  packDetail: any;
};

function ExportModal(props: ExportModalProps) {
  const navigate = useNavigate();
  const templateOptions = useSelector((state: RootState) => state.qCDetailPageState.templateOptions);
  const exportLoading = useSelector((state: RootState) => state.qCDetailPageState.exportLoading);
  const templateOptionLoading = useSelector((state: RootState) => state.qCDetailPageState.templateOptionsLoading);

  const [error, setError] = useState<string>("");

  const [successBoolean, setSuccessBoolean] = useState(false); // = useState
  const [templateType, setTemplateType] = useState(""); // = useState

  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const selectedTemplate = useWatch("Template", form);

  useEffect(() => {
    if (props.openState) {
      dispatch(
        getTemplateOptions({
          id: props.packDetail.idTenant,
          type: props.packDetail.transcriptions[0].transcriptionType,
        })
      );
    }

    return () => {
      form.resetFields();
      setTemplateType("");
      setError("");
    };
  }, [props.openState]);

  const resetForm = () => {
    if (successBoolean) {
      setSuccessBoolean(false);
    }
    form.resetFields();
  };

  const ExportModalContent = useMemo(() => {
    const onFinish = async () => {
      setTemplateType(form.getFieldValue("Template"));
      try {
        await dispatch(
          exportTemplate({
            id: props.packDetail.transcriptions[0].idTranscription,
            type: form.getFieldValue("Template"),
          })
        ).unwrap();
        setSuccessBoolean(true);
        resetForm();
      } catch (error) {
        console.error("Error exporting template:", error);
        setError("An error occurred while exporting the template. Please try again.");
      }
    };

    return (
      <div className="export-modal-inner">
        <>
          <h4>Export Options</h4>
          <p>Please choose the template to export with:</p>

          {/* {uploadLoading && (
            <div className="loading-spinner">
              <div className="loader">spin</div>
            </div>
          )} */}

          <div className="export-form-container">
            <Form
              form={form}
              name="exportOptions"
              onFinish={onFinish}
              initialValues={{ isDummyDomain: false }}
              colon={false}>
              <Form.Item
                className=""
                label="Export Template"
                name="Template"
                labelAlign="left"
                required={true}
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]*$/,
                    message: "Please provide a valid Template.",
                  },
                ]}
                validateTrigger="onBlur">
                <Select
                  className="form-item d-flex flex-column"
                  showSearch
                  placeholder="Select template"
                  optionFilterProp="children">
                  {templateOptions.map((template: any) => (
                    <Select.Option
                      key={template.value}
                      value={template.value}>
                      {template.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}

              <div className="d-flex gap-3 justify-content-end">
                <Button
                  className="saveButton"
                  type="primary"
                  loading={exportLoading}
                  htmlType="submit"
                  disabled={!selectedTemplate}>
                  Export
                </Button>

                <Button
                  className="cancelButton"
                  htmlType="reset"
                  loading={exportLoading}
                  onClick={() => {
                    props.close();
                    resetForm();
                  }}>
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </>
      </div>
    );
  }, [form, props, exportLoading, error, selectedTemplate, templateOptions]);

  const SuccessModalContent = useMemo(() => {
    return (
      <div className="export-modal-inner">
        <div className="success-message">
          <div className="success-header">
            <Spin className="spinner" />
            <h4 className="size24">Preparing your export</h4>
          </div>

          <p className="size16">
            Thank you for selecting <span>{templateOptions.find((template: any) => template.value === templateType)?.label || templateType}</span> for export. You will be notified via email when your Transcription is complete.
          </p>
        </div>
      </div>
    );
  }, [templateType]);

  return (
    <Modal
      width={successBoolean ? 500 : 376}
      className="modal-container"
      centered
      loading={templateOptionLoading}
      zIndex={1500}
      footer={[]}
      onCancel={() => {
        if (successBoolean) {
          navigate(-1);
        }
        resetForm();
        props.close();
      }}
      open={props.openState}>
      {!successBoolean ? ExportModalContent : SuccessModalContent}
    </Modal>
  );
}

export default ExportModal;
